import React from "react";
import { Upload, FileText, Trash2 } from "lucide-react";

const FileUploadSection = ({
  title,
  formValues,
  fileFieldName,
  existingFilesFieldName,
  fileError,
  onFileChange,
  onRemoveFile,
  getFileName
}) => {
  const files = formValues[fileFieldName] || [];
  const existingFiles = formValues[existingFilesFieldName] || [];

  return (
    <div className="form-section user-file-section">
      <span className="section-title">{title}</span>
      <div className="user-file-upload">
        <label className="user-file-dropzone">
          <input
            type="file"
            accept=".pdf,application/pdf"
            onChange={onFileChange}
            className="hidden-input"
            multiple
          />
          <Upload className="upload-icon" size={32} />
          <span className="upload-text">Click to upload PDF documents</span>
          <span className="upload-hint">PDF files only, max 5MB per file. You can select multiple files.</span>
        </label>
        
        {fileError && <p className="error-text">{fileError}</p>}
        
        {existingFiles.length > 0 && (
          <div className="files-list">
            <span className="files-list-title">Existing Files:</span>
            {existingFiles.map((fileUrl, index) => (
              <div key={`existing-${index}`} className="user-file-preview">
                <div className="file-info">
                  <FileText className="file-icon" size={20} />
                  <span className="file-name">{getFileName(fileUrl)}</span>
                </div>
                <div className="file-actions">
                  <a
                    href={fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="view-file-button"
                  >
                    View
                  </a>
                  <button
                    type="button"
                    className="remove-file-button"
                    onClick={() => onRemoveFile(index, true)}
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        
        {files.length > 0 && (
          <div className="files-list">
            <span className="files-list-title">New Files to Upload:</span>
            {files.map((file, index) => (
              <div key={`new-${index}`} className="user-file-preview">
                <div className="file-info">
                  <FileText className="file-icon" size={20} />
                  <div className="file-details">
                    <span className="file-name">{file.name}</span>
                    <span className="file-size">{(file.size / 1024).toFixed(1)} KB</span>
                  </div>
                </div>
                <div className="file-actions">
                  <button
                    type="button"
                    className="remove-file-button"
                    onClick={() => onRemoveFile(index, false)}
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUploadSection;

